export default {
  whatsNew: {
    title: "What's new — {version}",
    viewFullHistory: "View full history →",
    gotIt: "Got it",
  },
};
